import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";
import ImageViewer from "../../../components/ImageViewer";
import { printDate, printLocation } from "../../../utils/helper";
import React, { useState, useEffect } from "react";
import { user as userAPI, publicLink, location, asset } from "../../../api";
import { parserAPI } from "../../../utils/parser";
import { useQuery } from "@tanstack/react-query";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import NormalInput from "../../../components/form/HorizontalNormalInput";

import ConfirmationDlg from "../../../components/ConfirmationDlg";
import Select, { StylesConfig } from "react-select";
import { PermissionChecker } from "../../../components/PermissionChecker";
import { isPermissionAllowed } from "../../../components/PermissionChecker/permissionChecker";
import { useAuth } from "../../../contexts/AuthContext";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";

const colourStyles = {
    control: (styles) => ({
        ...styles,
        backgroundColor: "rgba(0, 0, 0, 0.48)",
        borderColor: "var(--bs-border-color)",
    }),
    input: (styles) => ({
        ...styles,
        color: "white",
    }),
    menu: (styles) => ({
        ...styles,
        color: "grey",
    }),
};

function getLeafLocationsWithPath(locations) {
  const result = [];

  function traverse(location, path) {
    const currentPath = [...path, location.location_name];

    if (!location.sublocations || location.sublocations.length === 0) {
      result.push({
        value: location.id,
        label: currentPath.join(" | "),
      });
    } else {
      location.sublocations.forEach((sublocation) =>
        traverse(sublocation, currentPath)
      );
    }
  }

  locations.forEach((location) => traverse(location, []));

  return result;
}

function PublicLinkConfiguration() {
  const [openDetail, setOpenDetail] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [confirmDlg, setConfirmDlg] = useState(false);
  const [openModalPublicLink, setOpenModalPublicLink] = useState(false);
  const [teamName, setPublicLinkName] = useState("");
  const [member, setMember] = useState([]);
  const [users, setUsers] = useState([]);
  const [locations, setLocations] = useState([]);
  const [assets, setAssets] = useState([]);
  const [teams, setPublicLinks] = useState([]);

  const [name,setName] = useState("");
  const [password,setPassword] = useState("");
  const [confirmPassword,setConfirmPassword] = useState("");
  const [locationId,setLocationId] = useState("");
  const [url,setUrl] = useState("");
  const [isActive,setIsActive] = useState(1);
  const [isPasswordActive,setIsPasswordActive] = useState(0);

  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteRow, setDeleteRow] = useState(null);
  const [query, setQuery] = useState({ page: 1, take: 10, totalData: 1 });
  const [loading, setLoading] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState([]);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const { allowedPermissions } = useAuth();
  const { selectedApp } = useDashboardContext();
    const [host, setHost] = useState("");
  async function getUser() {
    try {
      const res = await userAPI.list();
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.length) {
          let tmp = [];
          data.map((i, index) => {
            let item = i;
            item.id = index + 1;
            tmp.push(item);
          });
          setUsers(tmp);
          setIsDirty(false);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getPublicLink() {
    try {
      setLoading(true);
      const res = await publicLink.list(query);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setPublicLinks(data.results);
          setIsDirty(false);
        } else {
          setPublicLinks([]);
          setIsDirty(false);
        }

        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData: data.totalData,
          }));
        }
        setLoading(false);
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  async function getLocation() {
    const res = await location.list();
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      const leafLocations = getLeafLocationsWithPath(data);
      const parent = data.filter(z=> !z.parent_location_id)
        const val = parent.map(z=> {
            return {value:z.id, label:z.location_name}
        })
      setLocations(val);
    }
  }

  async function getAsset() {
    const res = await asset.list();
    if (res.ok) {
      const body = await res.json();
      const data = body.data;
      setAssets(
        data.map((i) => ({
          value: i.id,
          label: i.asset_name,
          location_id: i.location_id,
        }))
      );
    }
  }

  useEffect(() => {
    getPublicLink();
  }, [query.page, query.take, isDirty]);

  useEffect(() => {
    getUser();
    getLocation();
    getAsset();
      const origin = window.location.origin;
      setHost(origin);
  }, []);

  function selectUser(value) {
    //console.log("selected machine", value);
  }
  function addUser(value) {
    setSelectedRow(null);
    setOpenModalPublicLink(true);
    setName("");
    setUrl("");
    setPassword("");
    setConfirmPassword("");
    setIsActive(1);
    setIsPasswordActive(0)
    setMember([]);
    setSelectedLocation([]);
    setSelectedAsset([]);
    setFilteredAssets([]);
  }
  function editUser(value) {
    setSelectedRow(value);
    setOpenModalPublicLink(true);
    setPublicLinkName(value.team_name);
    setSelectedLocation(
      value.PublicLinkLocation.map((location) => ({
        value: location.location.id,
        label: locations.find((l) => l.value === location.location.id)?.label,
      }))
    );

    const location_id = value.PublicLinkLocation.map((l) => l.location.id);
    setPassword("")
    setConfirmPassword("")
    setName(value.name)
      setIsActive(value.isActive)
      setUrl(value.url)
      setIsPasswordActive(value.isPasswordActive)
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
    setConfirmDlg(true);
  }
  function hideConfirmationDialog() {
    setDeleteRow(null);
    setConfirmDlg(false);
  }
    const copyClipboard = (url) => {
        const host = window.location.origin;
        navigator.clipboard.writeText(url);
        toast.success("Link Copied to clipboard");
    };
  async function deleteUser() {
    try {
      const res = await publicLink.delete(deleteRow.id);
      if (res.ok) {
        toast.success("This team has been deleted");
        setConfirmDlg(false);
        setDeleteRow(null);
        const body = await res.json();
        setIsDirty(true);
        await getPublicLink();
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }
  const columns = [
    {
      name: "Link Name",
        minWidth: "150px",
      selector: (row) => row.name,
    },
    {
      name: "URL",
      minWidth: "250px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <span>  {host}/public-request/{row.url}</span>;
      },
    },
    {
      name: "Location",
      minWidth: "260px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return <div>
            {
                row.PublicLinkLocation?.map(p=>{
                    return <span className={"custom-badge-loc"}>{p.location?.location_name}</span>
                })
            }
        </div>;
      },
    },
    {
      name: "Action",
      width: "350px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => {
        return (
          <div>
            <PermissionChecker permissions={["edit team"]} hideIfNotAllowed>
              <button
                onClick={() => {
                    copyClipboard(`${host}/public-request/${row.url}`);
                }}
                className="btn btn-sm btn-outline-theme mx-1"
              >
                <i className="fa fa-paper-plane"></i> Share
              </button>
            </PermissionChecker>
            <PermissionChecker permissions={["edit team"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  editUser(row);
                }}
                className="btn btn-sm btn-outline-theme mx-1"
              >
                <i className="fa fa-edit"></i>
              </button>
            </PermissionChecker>
            <PermissionChecker permissions={["delete team"]} hideIfNotAllowed>
              <button
                onClick={() => {
                  showConfirmationDlg(row);
                }}
                className="btn btn-sm btn-outline-danger"
              >
                <i className="fa fa-trash"></i>
              </button>
            </PermissionChecker>
          </div>
        );
      },
    },
  ];

  async function onSubmitPublicLink() {
    setLoadingSubmit(true);
    if(!selectedLocation.length){
        toast.error("Please select location");
        return
    }
    if(isPasswordActive==1 && password !== confirmPassword){
        toast.error("Password is now match");
        return
    }
    if(isPasswordActive==1 && password ===''){
        toast.error("Password Cannot be empty");
        return
    }
    let data = {
      name: name,
        url,
      password: password,
        locations: selectedLocation.map((i) => i.value),
        isPasswordActive: isPasswordActive==1 ,
        isActive: isActive==1,
    };
    console.log({ data });
    if (!selectedRow) {
      const response = await publicLink.create2(data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("PublicLink " + teamName + " is successfully added");
          setSelectedRow(null);
          setOpenModalPublicLink(false);
          setIsDirty(true);
          await getPublicLink();
        } else {
          toast.error(body.message);
        }
      } else {
          const body = await response.json();
        toast.error(body.message);
      }
    } else {
      const response = await publicLink.update(selectedRow.id, data);
      if (response.ok) {
        const body = await response.json();
        //console.log({ body });
        if (body.success) {
          //toast.success(body.message);
          toast.success("PublicLink " + teamName + " is successfully updated");
          setSelectedRow(null);
          setOpenModalPublicLink(false);
          setIsDirty(true);
          await getPublicLink();
        } else {
          toast.error(body.message);
        }
      } else {
        toast.error("API Error");
      }
    }
    setLoadingSubmit(false);
  }

  const handleChangeLocation = (e) => {
    setSelectedLocation(e);
  };
  return (
    <div>
      <ConfirmationDlg
        loading={loadingSubmit}
        open={openModalPublicLink}
        onSubmit={onSubmitPublicLink}
        btnSubmitText={"Save"}
        title={"Add PublicLink"}
        btnCancelText={"Cancel"}
        onClose={() => {
          setOpenModalPublicLink(false);
        }}
        hideSubmitBtn={
          !isPermissionAllowed(allowedPermissions, selectedApp, ["edit team"])
        }
      >
        <NormalInput
          required={true}
          value={name}
          type={"text"}
          label="Link Name"
          onchange={(e) => {
            setName(e.target.value);
          }}
          name="name"
        />
        <NormalInput
          required={true}
          value={url}
          type={"text"}
          label="URL"
          onchange={(e) => {
            setUrl(e.target.value);
          }}
          name="name"
        />
          <div>
              <div className={"alert alert-info"}>
                  {host}/public-request/{url}
              </div>
          </div>

        <div className="mb-3 force-transparent force-white" style={{ zIndex: 9999999 }}>
          <label className="form-label">Assign to Locations</label>
          <Select
            isMulti={true}
            styles={colourStyles}
            options={locations}
            value={selectedLocation}
            onChange={(e) => {
              handleChangeLocation(e);
            }}
          />
        </div>

        <div className="mb-3 force-transparent" style={{ zIndex: 9999999 }}>
          <label className="form-label">Is Active?</label>
            <select style={{
                backgroundColor: "rgba(0, 0, 0, 0.48)"
            }} className={"form-control"} name="" id="" value={isActive} onChange={(e) => {
                setIsActive(e.target.value);

            }}>
                <option value={1}>Yes</option>
                <option value={0}>No</option>
            </select>
        </div>
        {/*<div className="mb-3 force-transparent" style={{ zIndex: 9999999 }}>*/}
        {/*  <label className="form-label">Using Password?</label>*/}
        {/*    <select style={{*/}
        {/*        backgroundColor: "rgba(0, 0, 0, 0.48)"*/}
        {/*    }} className={"form-control"} name="" id="" value={isPasswordActive} onChange={(e) => {*/}
        {/*        setIsPasswordActive(e.target.value);*/}
        {/*    }}>*/}

        {/*        <option value={1}>Yes</option>*/}
        {/*        <option value={0}>No</option>*/}
        {/*    </select>*/}
        {/*</div>*/}
          {
           isPasswordActive==1   ? <>
               {selectedRow ? <div>
                   Leave the Password Blank if you don't want to change it
               </div> : ""}
               <NormalInput
               required={true}
               value={password}
               type={"password"}
               label="Password"
               onchange={(e) => {
                   setPassword(e.target.value);
               }}
               name="name"
           />
               <NormalInput
                   required={true}
                   value={confirmPassword}
                   type={"password"}
                   label="Confirm Password"
                   onchange={(e) => {
                       setConfirmPassword(e.target.value);
                   }}
                   name="name"
               /></> : null
          }

      </ConfirmationDlg>
      <ConfirmationDlg
        open={confirmDlg}
        onClose={() => {
          setConfirmDlg(false);
          setDeleteRow(null);
        }}
        onSubmit={deleteUser}
      >
        <div>Are you sure you want to delete this PublicLink?</div>
      </ConfirmationDlg>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Configuration</a>
            </li>
            <li className="breadcrumb-item active">Request</li>
          </ol>
          <h1 className="page-header mb-0">Public Link</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12 ">
          <div className="row justify-content-end">
            <div className="col-sm-3 mb-2 mb-sm-0">
              <PermissionChecker permissions={["create team"]} hideIfNotAllowed>
                <button
                  onClick={addUser}
                  className="btn btn-outline-theme w-100"
                >
                  Add New <i className="bi bi-plus"></i>
                </button>
              </PermissionChecker>
            </div>
          </div>
          <Card className="mb-4 mt-2">
            <CardHeader>List Public Link</CardHeader>
            <CardBody>
              <DataTable
                progressPending={loading}
                pointerOnHover
                onRowClicked={(row) => {
                  editUser(row);
                }}
                highlightOnHover
                theme="dark"
                columns={columns}
                data={teams}
                pagination
                paginationServer
                onChangeRowsPerPage={(row) =>
                  setQuery((prev) => ({ ...prev, page: 1, take: row }))
                }
                paginationTotalRows={query.totalData}
                onChangePage={(page) =>
                  setQuery((prev) => ({ ...prev, page: page }))
                }
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default PublicLinkConfiguration;
